'use client';
import * as React from 'react';
import { forwardRef } from 'react';
import classNames from 'clsx';
import styles from './link.module.scss.js';

/**
 * Компонент Link
 */
const Link = /*#__PURE__*/forwardRef(({
  download,
  icon,
  onMouseOver,
  onMouseLeave,
  onClick,
  onFocus,
  onBlur,
  iconPosition = 'end',
  children,
  rel,
  target,
  href,
  size = 'm',
  color = 'primary'
}, ref) => /*#__PURE__*/React.createElement("a", {
  ref: ref,
  href: href,
  onClick: onClick,
  onBlur: onBlur,
  onFocus: onFocus,
  onMouseOver: onMouseOver,
  onMouseLeave: onMouseLeave,
  target: target,
  rel: rel,
  download: download,
  className: classNames(styles['mtsds-link'], styles[`mtsds-link--size--${size}`], styles[`mtsds-link--text-color--${color}`])
}, icon && iconPosition === 'begin' && /*#__PURE__*/React.createElement("div", {
  className: styles['mtsds-link__icon']
}, icon), /*#__PURE__*/React.createElement("p", {
  className: styles['mtsds-link__text']
}, children), icon && iconPosition === 'end' && /*#__PURE__*/React.createElement("div", {
  className: styles['mtsds-link__icon']
}, icon)));
Link.defaultProps = {
  icon: undefined,
  size: 'm',
  color: 'primary',
  target: '_blank',
  rel: undefined,
  download: undefined
};

export { Link, Link as MtsDsLink };
